import { PannellumStadiumCamera } from 'app/models/pannellum-stadium-camera';
import {SharepointData} from 'app/models/sharepoint-data';

export class Competition {
  id: string;
  displayName: string;
  logoUrl: string | ArrayBuffer;
  logoFile: string;
  backgroundFile: string;
  backgroundUrl: Blob;
  stadiumFile: string;
  stadiumUrl: Blob;
  assetBackground?: SharepointData;
  assetStadium?: SharepointData;
  footerImageFile?: string;
  footerImageUrl?: Blob;
  assetFooterImage?: SharepointData;
  is_public: boolean;
  hide_stadium: boolean;
  hide_uptop_logo?: boolean;
  has_footer_image?: boolean;
  compUrl: string;
  custom_title?: string;
  constructor(
    id: string,
    displayName: string,
    logoUrl: string,
    logoFile: string,
    backgroundFile: string,
    backgroundUrl: Blob,
    assetBackground?: SharepointData,
    is_public?: boolean,
    hide_stadium?: boolean,
    compUrl?: string,
  ) {
    this.id = id;
    this.displayName = displayName;
    this.logoFile = logoFile;
    this.logoUrl = logoUrl;
    this.backgroundFile = backgroundFile;
    this.backgroundUrl = backgroundUrl;
    this.assetBackground = assetBackground;
    this.is_public = is_public;
    this.hide_stadium = hide_stadium;
    this.compUrl = compUrl;
  }
}
